import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Payyitme.module.css';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const CallToAction = () => (
  <section className={styles.footcta}>
    <div className={styles.container}>
      <span className={`${styles.eyebrow} ${styles.sr}`} data-sr><span className={styles.dot} />Get started</span>
      <h2 className={styles.sr} data-sr style={{ marginTop: 18 }}>Get your Lynk today.</h2>
      <p className={styles.sr} data-sr>A fast, easy way for friends, family, or customers to pay you back.</p>
      <div className={styles.sr} data-sr>
        <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Create your Lynk</Link>
      </div>
    </div>
  </section>
);

export default CallToAction;
